/*
 * @Author: 冯嘉妍 alice1@gm99.com
 * @Date: 2025-12-03 11:29:22
 * @LastEditors: 冯嘉妍 alice1@gm99.com
 * @LastEditTime: 2026-05-20 11:33:59
 * @FilePath: /resource_gssr.37games.com/src/br/stores/userAgreement.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Vuex from 'vuex';
import options from '../../resource/store';
Vue.use(Vuex);

export default new Vuex.Store(options);
